module.exports = __webpack_public_path__ + "static/media/download_report.b7ee33e2.svg";